import React from 'react';
import { View } from 'react-native';
import { Icon } from '..';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export function Skill({ name, rating, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular' }, name),
        rating ? (React.createElement(View, { style: styles.ratingContainer }, new Array(5).fill(0).map((_, i) => {
            return (React.createElement(Icon, { key: i, name: 'star', size: 14, filled: true, color: (c) => (i < rating ? c.warning.solid : c.invert2.p10) }));
        }))) : null));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        padding: size.D,
        backgroundColor: color.invert2.p4,
        borderRadius: 999,
        flexDirection: 'row',
        alignItems: 'center'
    },
    ratingContainer: {
        marginLeft: size.C,
        paddingVertical: size.B,
        paddingHorizontal: size.C,
        backgroundColor: color.bg.v1,
        borderRadius: size.G,
        flexDirection: 'row'
    }
}));
//# sourceMappingURL=index.js.map